module.exports = "\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/adpTint/adpTint.html
// module id = 609
// module chunks = 0